export const HELPFUL_LINKS_SECTION_TITLE = 'Useful links';

const REACT_APP_MY_ACCOUNT_DOMAIN = import.meta.env.VITE_MY_ACCOUNT_DOMAIN;
export const USEFUL_LINKS = [
  {
    id: 'myAccount',
    text: 'My Account',
    link: `${REACT_APP_MY_ACCOUNT_DOMAIN}/Account/LoginRedirect.aspx`,
    analytics: 'Manage your BT account online',
  },
  {
    id: 'helpAndSupport',
    text: 'Help & support',
    link: 'https://business.bt.com/help/home/',
    analytics: 'Help & support:top',
  },
  {
    id: 'downloadBtBussinessApp',
    text: 'Download BT Business App',
    link: 'https://business.bt.com/comms/business-app/',
    analytics: 'Download BT Business App',
  },
];
